import { useLoanApplication } from '@axo/shared/data-access/hooks';
import { Product } from '@axo/shared/data-access/types';
import { useParams } from 'react-router-dom';

export function useShouldUseAssignmentV3({
  applicationID,
  marketCountry,
}: {
  applicationID?: string;
  marketCountry?: string;
}) {
  const { applicationID: routeApplicationID } = useParams();
  const resolvedID = applicationID ?? routeApplicationID;

  const { data: applicationData } = useLoanApplication(resolvedID);

  const resolvedMarketCountry = applicationData?.MarketCountry ?? marketCountry;
  const product = applicationData?.Product;

  if (resolvedMarketCountry === 'DK') return true;

  if (resolvedMarketCountry === 'NO' && product === Product.SecuredLoan) return true;

  return false;
}
